export const HttpVerb = {
  PUT : 'put',
  GET : 'get',
  POST : 'post',
  PATCH : 'patch',
  DELETE : 'delete'
} as const;

type HttpVerbType = typeof HttpVerb[keyof typeof HttpVerb];

export type { HttpVerbType };
